export default "__VITE_ASSET__g7m8_6Tk__"